import React from 'react';

const SdkPicker2 = ({ visibility }) =>
  <div className={`step-hidden-visibility ${visibility ? 'step-visibility' : ''}`}>
    <svg
      width="555"
      height="528"
      viewBox="0 0 555 528"
      className="sdk-picker-2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMinYMin meet"
    >
      <defs>
        <rect id="path-1" x="5" y="102" width="162" height="54" rx="3.6" />
        <filter
          x="-54.3%"
          y="-142.6%"
          width="208.6%"
          height="425.9%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <femorphology radius="2.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1">
            <feoffset dy="11" in="shadowSpreadOuter1" result="shadowOffsetOuter1">
              <fegaussianblur stdDeviation="25" in="shadowOffsetOuter1" result="shadowBlurOuter1">
                <fecolormatrix
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                  in="shadowBlurOuter1"
                />
              </fegaussianblur>
            </feoffset>
          </femorphology>
        </filter>
        <ellipse id="path-3" cx="22.5" cy="22.443" rx="21.625" ry="21.526" />
      </defs>
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0 -37)">
          <g id="Group-2" transform="translate(0 42)">
            <g id="Body">
              <rect id="Rectangle" fill="#F7F7F7" width="555" height="528" rx="3" />
              <path
                d="M56.4356434,49.2693135 L53.4053728,39.9995532 L61.3374882,34.2720838 L51.5325397,34.2720838 L48.5019094,25.002681 L48.5010102,25.0001787 L58.3075773,25.0001787 L61.3387471,34.2711902 L61.3387471,34.2710114 L61.3412648,34.2695816 C63.101879,39.6479872 61.2887521,45.7652712 56.4356434,49.2693135 L56.4356434,49.2693135 L56.4356434,49.2693135 Z M40.5678157,49.2693135 L40.565298,49.2711008 L48.4995715,55 L56.4356434,49.2694922 L48.5020892,43.5404143 L40.5678157,49.2693135 L40.5678157,49.2693135 L40.5678157,49.2693135 Z M35.6638128,34.2697603 L35.6638128,34.2697603 C33.8107619,39.9393205 35.9618044,45.946863 40.5661972,49.2703859 L40.5669166,49.2675262 L43.5975468,39.998302 L35.6670499,34.2719051 L45.4696606,34.2719051 L48.5004707,25.0025022 L48.50119,25 L38.6940834,25 L35.6638128,34.2697603 L35.6638128,34.2697603 L35.6638128,34.2697603 Z"
                id="Shape"
                fill="#EB5424"
              />
              <path
                d="M35,87 L95,87"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <path
                d="M35,109 L75,109"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <path
                d="M35,131 L85,131"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <path
                d="M35,153 L105,153"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <path
                d="M35,175 L75,175"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <path
                d="M35,197 L55,197"
                id="Line"
                stroke="#000"
                strokeWidth="4"
                opacity=".11"
                strokeLinecap="square"
              />
              <text
                id="Platform"
                fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="24"
                fontWeight="400"
                fill="#333"
              >
                <tspan x="145" y="96">Platform</tspan>
              </text>
              <rect
                id="Rectangle-3"
                stroke="#000"
                strokeWidth="2"
                opacity=".11"
                x="146"
                y="133"
                width="142"
                height="95"
                rx="2.7"
              />
              <circle
                id="Oval-3"
                strokeOpacity=".11"
                stroke="#000"
                strokeWidth="2"
                cx="216"
                cy="170"
                r="18"
              />
              <text
                id="Angular"
                opacity=".11"
                fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11"
                fontWeight="500"
                fill="#000"
              >
                <tspan x="196" y="209">Angular</tspan>
              </text>
              <rect
                id="Rectangle-3"
                stroke="#000"
                strokeWidth="2"
                opacity=".11"
                x="316"
                y="133"
                width="142"
                height="95"
                rx="2.7"
              />
              <circle
                id="Oval-3"
                strokeOpacity=".11"
                stroke="#000"
                strokeWidth="2"
                cx="387"
                cy="170"
                r="18"
              />
              <text
                id="Ember"
                opacity=".11"
                fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11"
                fontWeight="500"
                fill="#000"
              >
                <tspan x="370" y="209">Ember</tspan>
              </text>
              <rect
                id="Rectangle-3"
                stroke="#000"
                strokeWidth="2"
                opacity=".11"
                x="316"
                y="256"
                width="142"
                height="95"
                rx="2.7"
              />
              <circle
                id="Oval-3"
                strokeOpacity=".11"
                stroke="#000"
                strokeWidth="2"
                cx="387"
                cy="293"
                r="18"
              />
              <text
                id="React"
                opacity=".11"
                fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11"
                fontWeight="500"
                fill="#000"
              >
                <tspan x="371.99" y="332">React</tspan>
              </text>
              <g id="Group-6" transform="translate(130 206)">
                <use
                  filter="url(#filter-2)"
                  xlinkHref="#path-1"
                  id="Rectangle-17"
                  opacity=".464"
                  fill="#000"
                />
                <rect id="Rectangle-3" fill="#FFF" width="173" height="156" rx="3.24" />
                <g id="Group-7" transform="translate(64 23)">
                  <mask id="mask-4" fill="#fff">
                    <use xlinkHref="#path-3" />
                  </mask>
                  <use
                    id="Oval-3"
                    strokeOpacity=".25"
                    stroke="#FFF"
                    strokeWidth="2.4"
                    xlinkHref="#path-3"
                  />
                  <g id="Group-8" mask="url(#mask-4)">
                    <g transform="translate(1 1)">
                      <polygon
                        id="Fill-1"
                        fill="#F1DC29"
                        points="0 42.8411121 42.8411121 42.8411121 42.8411121 0 0 0"
                      />
                      <path
                        d="M9.60441704,25.7543004 C10.2368834,26.8763498 10.8120807,27.8250493 12.1952152,27.8250493 C13.5179955,27.8250493 14.3523498,27.3075067 14.3523498,25.2953767 L14.3523498,11.6065291 L18.3779596,11.6065291 L18.3779596,25.3497534 C18.3779596,29.5182466 15.9340942,31.4154529 12.3666368,31.4154529 C9.1433722,31.4154529 7.27682511,29.7473229 6.32735426,27.738278 L9.60441704,25.7543004 Z M23.8256547,25.4054798 C24.6885471,26.8144529 25.8113677,27.8501166 27.7968879,27.8501166 C29.4650179,27.8501166 30.5305695,27.0163408 30.5305695,25.8644036 C30.5305695,24.4839686 29.4357085,23.995157 27.5998206,23.1920404 L26.5932735,22.7601121 C23.6883632,21.5225605 21.7583767,19.9720538 21.7583767,16.6944126 C21.7583767,13.675157 24.0589731,11.3766816 27.6541973,11.3766816 C30.2137578,11.3766816 32.0538879,12.2675336 33.3799462,14.5999462 L30.2449955,16.6128475 C29.5548744,15.375296 28.8101839,14.8876413 27.6541973,14.8876413 C26.4750717,14.8876413 25.7276816,15.6356099 25.7276816,16.6128475 C25.7276816,17.8205112 26.4756502,18.3095157 28.2029776,19.0574843 L29.2093318,19.4886413 C32.6298565,20.9554619 34.561,22.4508206 34.561,25.8127265 C34.561,29.4372601 31.7139372,31.4229731 27.8900224,31.4229731 C24.1513363,31.4229731 21.736009,29.6412691 20.553991,27.306157 L23.8256547,25.4054798 L23.8256547,25.4054798 Z"
                        id="Fill-2"
                        fill="#0A0A08"
                      />
                    </g>
                  </g>
                </g>
                <text
                  id="Javascript"
                  opacity=".7"
                  fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                  fontSize="13.2"
                  fontWeight="500"
                  fill="#060A1C"
                >
                  <tspan x="54.708" y="91.928">Javascript</tspan>
                </text>
                <g id="Default" transform="translate(50 102)">
                  <g className="animate-button">
                    <rect id="Rectangle-16" fill="#EB5424" width="73" height="34" rx="2" />
                    <text
                      id="SELECT"
                      fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                      fontSize="12"
                      fontWeight="500"
                      letterSpacing=".427"
                      fill="#FFF"
                    >
                      <tspan x="15" y="20">SELECT</tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
            <rect
              id="Rectangle-2"
              fill="#F7F7F7"
              transform="matrix(1 0 0 -1 0 8)"
              width="555"
              height="8"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>;

export default SdkPicker2;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/svg/SdkPicker2.js